import { FC, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import ReactTooltip from "react-tooltip";
import { useToasts, FlexBox, BLangSwitcher, useBreakpoint } from '@brg/ui';
import { API, Endpoints, Tag } from '@brg/api';
import {
  TagsAvailableTitle,
  ModalContextSplitLine, TabletTitle,
  TagsSearchInput,
  TagsSearchInputWrapper,
  TagsSearchModalContainer,
  TagsSearchModalWrapper,
  TagsSearchResults,
  TagsSearchResultsContext,
  TagsSearchSelection,
  TagsSearchTitle,
  TagsSelectedTitle,
  SubmitButton,
  LangSelectHolder,
  TagsSearchResultsWrapper,
  TitleContainer,
} from './styles';
import { TagsSearchResultsItem } from './tagsSearchResultsItem';
import { BTag } from '../../../core/components';
import { bTag, LayoutConst, useModal } from '../../../core';
import { ITagsProps } from 'shared/hooks/api/useTagsList';
import { EmptyText, EmptyTextWrapper } from './FoundTags';
import { debounceEvent } from 'shared/utils/debounce';
import { useDispatch, useSelector } from 'react-redux';
import { TagsActions, TagsSelector } from 'shared/reducers/Tags';
import { ArrowTopRightIcon, SearchIcon } from 'shared/icons';
import { CreateLinkTo } from 'shared/constants/linkTo';
import { AGEYTOMESH_TAG_ID } from 'shared/constants/misc';
import { getSearched, getUpdated } from './support/updateTag';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { filterChildrens } from './support/filterChildrens';
import { AppTester } from 'supporting';
import { SaveUserLang } from "../../components/__ADDONS__/__LANG__/Utils/GetUserLang";
import { setAppLang } from "../../components/__ADDONS__/__LANG__/Slice";
import { setInitialChildrens } from './support/setInitialChildrens';
import { useContextsTabs } from 'shared/hooks/useContextsTabs';
import { isRequired } from './support/isRequired';
import { LoaderSpinner } from "../artzLegalsModal/LoaderAnimation";
import CategoryList from "./CategoryList";
import { useGetAllTags } from 'shared/hooks/api/useGetAllTags';
import useQueryState from 'shared/hooks/useQueryState';
import { SimplePagination } from 'shared/components/pagination/SimplePagination';
import { extractTagChilds } from './support/extractTagChilds';
import { removeUndefined } from "../../helpers/removeUndefined";
import { CreateTagButton } from './components/CreateTagComponent/style';
import { CreateTagComponent } from './components/CreateTagComponent/CreateTagComponent';
import { getTooltipStyles } from 'shared/constants/tooptipStyles';
import {BTagsGridNew} from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import {useGetApiTags} from "../../hooks/api/useGetApiTags";
import {bProfile} from "../../../core/utils/bProfile";
import {useProfile} from "@brg/auth";
import { useInitialCategories } from './support/useInitialCategoires';
import { SelectTagsModalProps } from './types';

export interface IGrouppedTags<T> {
  isEducationTag?: boolean;
  categoryId?: string;
  childrens?: T;
  found?: number;
  position?: number;
  groupId?: string | null;
  categoryTitle?: string;
  isTagCategory?: boolean;
  isSearchButton?: boolean;
  isMoreButton?: boolean;
  isEmptyCategory?: boolean;
}

export enum LOAD_TYPE {
  initial = 1,
  update = 2,
  tagSearch = 3,
  tagsSearchIntoCategory = 4,
  tagSearchIntoTag = 5,
  tagGlobalSearchIntoTag = 6,
  tagSearchGlobal = 7,
  tagsFetchMore = 8,
  tagsFetchMoreLarge = 9,
  tagsFetchMoreLargeChild = 10,
  test = 11,
  updateLang = 12
}

export const LABORATORY_PARAM = '?_lab';
export const APPROVED_HSEDESIGN_PARAM = '';
export const REQUIRED_TAG_ID = '390ea8c2329fc0bc9c389a1b0f1f6e4d';
export const EDUCATIONAL_CATEGORY_ID = 'c326e5a4bd0b02c9c338fe382ac1f9a8';
export const ALL_TAGS_LIMIT = 100;


export const SelectTagsModal: FC<SelectTagsModalProps> = (props) => {
  const {
    value, onChange,
    mode,
    ctx,
    isCompetencies,
    max,
    maxProjectTags,
    maxPlacesTags,
    maxTeamsTags,
    onClose,
    onAfterTagCreate,
    hideGlobalSearchBar,
    maxEducationalTags,
    ungroup,
    protectedTags = [],
    editableTags = [],
    requiredTags,
    isTagEditor,
    isMobileMenu,
    isTagAdminPage,
    isEdit,
    educational,
    isCreateLocation,
    global: globalProp,
    hasEduTags,
    saveOnClick = true,
    viewAllTags,
    ignoreHeader,
  } = props;

  const [innerValue, setInnerValueFinal] = useState<Tag[]>(value ?? []);
  const [innerLocalValueRaw, setInnerLocalValue] = useState<Tag[]>([]);
  const location = useLocation();
  const valueRef = useRef<Tag[]>([]);
  const prevLangRef = useRef<string | null>(null);
  const tagSearchListRef = useRef();
  const activeTag = useRef<any>(null)
  const mainSearchRef = useRef<any>(null);
  const toasts = useToasts();
  const dispatch = useDispatch();
  const history = useHistory();
  const isTagsSearchPage = location.pathname.startsWith('/tags');
  const isEditProjectPage = location.pathname.startsWith('/edit');
  const isCreateLocationPage = location.pathname.startsWith('/createLocation');
  const isBrnd = AppTester.isBrnd();
  const isStartHSE = AppTester.isStartHSE();
  const [{ page }, setQueryState ] = useQueryState();

  const [hideMore, setHideMore] = useState(false);

  const isHSEdesign = AppTester.isHSEDesign();
  const isCGRAVE = AppTester.isCGRAVE();
  const isContinuumSite = AppTester.isContinuumSite();
  const isIqMediia = AppTester.isIqMediiia();
  const isHseSpace = AppTester.isHseSpace();
  const isFilmRoute = !!useRouteMatch('/film');
  const isMobile = useBreakpoint(LayoutConst.screen.s);
  const is992 = useBreakpoint(LayoutConst.screen.m);
  const theme = useTheme();
  const modal = useModal();
  const { t, i18n } = useTranslation();
  const [isCreateMode, setIsCreateMode] = useState(false);
  const [foundCategories, setFoundCategories] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchInitialParam, setInitialSearchParam] = useState<any>(null);
  const [currentCategory, setCurrentCategory] = useState<string | null>(null);
  const profile = useProfile()
  const isModer = bProfile.isModer(profile) || bProfile.isSuperModer(profile)
  const global = useMemo(() => ((Boolean(isTagEditor && !isModer && !!editableTags?.length)) || globalProp),
      [isModer, globalProp, isTagEditor])

  const handlePageChange = (p: number ) => {
    setQueryState({ page: p })
    setTime(Date.now());
  }

  const isLinkMode = mode === 'link';

  const optionTagsFilter = useMemo(() => ({
    isModeEditing: isEdit || false,
    ...(isStartHSE && isTagsSearchPage ? {
      isEducation: true,
    } : educational !== undefined ? {
      isEducation: educational,
    } : {}),
    ...(ctx  ? {
      entityTypes: ctx,
    } : {}),
    ...(isTagEditor && !isModer && editableTags ? {
      tagIds: editableTags || [],
    } : {}),
    ...(global ? {
      isHeaderIgnored: global,
    } : {}),
    ...(hasEduTags !== undefined && !(isStartHSE && isTagsSearchPage) ? {
      hasEduTags: hasEduTags,
    } : {}),
    ...(isBrnd && isEdit && ignoreHeader !== false ? {
      isHeaderIgnored: true,
    } : {}),
  }), [isModer, isEdit, educational, isTagEditor, global, ctx, hasEduTags, isStartHSE, isTagsSearchPage])

  useEffect(() => {
    if (
      searchText?.length && 
      isLinkMode && 
      prevLangRef.current && 
      prevLangRef.current !== i18n.language
    ) {
      setInitialSearchParam({ search: [ searchText ] })
    }
    prevLangRef.current = i18n.language
  } , [i18n.language, isLinkMode, searchText, prevLangRef.current])

  const initialTagsFilter = useMemo(() => ({
    ...optionTagsFilter,
    status: [0],
    lang: i18n.language,
    ...(searchInitialParam ? searchInitialParam : {})
  }), [i18n.language, optionTagsFilter, searchInitialParam])


  const appContext = isFilmRoute ? 'filmhsespace' : '';
  
  const initialCategoryList = useInitialCategories(optionTagsFilter);

  const finalCategoryList = useMemo(() => {

    return initialCategoryList
  } , [initialCategoryList])

  const initialAllTagsFilter = useMemo(() => ({
    status: 0,
    level: 1,
    isHeaderIgnored: true,
    includeCount: true,
    limit: ALL_TAGS_LIMIT,
    page: page ? page : 1
  }), [ctx, i18n.language, page, isEditProjectPage])

  const [tagsFilter, setTagsFilterFinal] = useState<ITagsProps>(initialTagsFilter);

  const setTagsFilter = useCallback((filter: ITagsProps) => {
    setTagsFilterFinal({
      ...removeUndefined(filter)
    })
  }, [optionTagsFilter, requiredTags])

  const [loadType, setLoadType] = useState<number>(LOAD_TYPE.initial);
  const [time, setTime] = useState(Date.now());
  const [_, setIsOpenTag] = useState<boolean>(false); /** TODO: почистить и проверить компоненты, в которые пробрасывается сеттер  */

  const isViewAllTagsMode = useMemo(() => {
    return viewAllTags && loadType !== LOAD_TYPE.tagSearchGlobal
  } , [viewAllTags, loadType])

  const requestsDisabled = isViewAllTagsMode || !finalCategoryList?.length || ([LOAD_TYPE.initial, LOAD_TYPE.tagsSearchIntoCategory].includes(loadType) && !tagsFilter?.groupIds);
  const shouldCacheValues = true;

  const [tagsEn, loadEn] = useGetApiTags({
    ...tagsFilter,
    lang: 'en',
  }, 'en', time, requestsDisabled, appContext);
  const [tagsRu, loadRu] = useGetApiTags({
    ...tagsFilter,
    lang: 'ru',
  }, 'ru', time, requestsDisabled, appContext);

  //@ts-ignore
  const [tagsAllEn, loadAllEn] = useGetAllTags({ ...initialAllTagsFilter }, 'en', time, !isViewAllTagsMode, shouldCacheValues);
  //@ts-ignore
  const [tagsAllRu, loadAllRu] = useGetAllTags({ ...initialAllTagsFilter }, 'ru', time, !isViewAllTagsMode, shouldCacheValues);

  const load = isViewAllTagsMode ? (loadAllEn || loadAllRu) : (loadEn || loadRu);

  const tags = useMemo(() => {
    if (i18n.language === 'ru') {
      //@ts-ignore
      return isViewAllTagsMode ? tagsAllRu?.data : tagsRu;
    }
    //@ts-ignore
    return isViewAllTagsMode ? tagsAllEn?.data : tagsEn;
  }, [i18n.language, tagsEn, tagsAllRu, tagsAllEn, tagsRu, isViewAllTagsMode]);

  useEffect(() => {
    if (finalCategoryList?.length) {
      setTagsFilter({
        ...initialTagsFilter,
        groupIds: [finalCategoryList[0]?.tagId],
        ...(isCreateLocation ? { entityTypes: [] } : {})
      })
      setTime(Date.now());
      setCurrentCategory(finalCategoryList[0]?.tagId);
    }
  }, [finalCategoryList, isCreateLocation, initialTagsFilter])

  useEffect(() => {
    if (!currentCategory && !isViewAllTagsMode) {
      setCurrentCategory(tags[0]?.tagId)
    }
  }, [tags, isViewAllTagsMode])

  useEffect(() => {
    if (loadType !== LOAD_TYPE.tagsSearchIntoCategory) {
        // @ts-ignore
      const categories = tags?.filter((tag) => tag.isSearchResult) || []
      const ALL = {
        tagId: 'all',
        title: 'все',
        name: 'все',
        level: 2,
      }
      // @ts-ignore
      setFoundCategories([ALL, ...categories]);
    }
  }, [tags])

  const { tagsList, newTag } = useSelector(TagsSelector);

  const isLaboratoryPage = window?.location.pathname.startsWith('/laboratory') || Boolean(window.location.href.split('?').find((l) => l === LABORATORY_PARAM.slice(1)));

  const isGlobalSearch = useMemo(
    () =>
      searchText.length > 0 &&
      (loadType === LOAD_TYPE.tagSearchGlobal
        || loadType === LOAD_TYPE.tagsFetchMore
        || loadType === LOAD_TYPE.tagsFetchMoreLarge
        || loadType === LOAD_TYPE.tagsFetchMoreLargeChild
        || loadType === LOAD_TYPE.tagSearch
        || loadType === LOAD_TYPE.tagSearchIntoTag
        || loadType === LOAD_TYPE.tagGlobalSearchIntoTag
        || loadType === LOAD_TYPE.tagsSearchIntoCategory
        || loadType === LOAD_TYPE.test
        || loadType === LOAD_TYPE.update)
    , [searchText, loadType]);

  useEffect(() => {
    if (!searchText.length && !!finalCategoryList?.length) {
      const category = finalCategoryList[0]?.tagId;
      setLoadType(LOAD_TYPE.tagsSearchIntoCategory);
      setCurrentCategory(category);
      setTagsFilter({
        ...initialTagsFilter,
        groupIds: [category],
        ...(isCreateLocation ? { entityTypes: [] } : {})
      })
    }
  }, [searchText, initialTagsFilter, isCreateLocation])

  const isLocalSearch = useMemo(
    () =>
      loadType === LOAD_TYPE.tagSearch
      || loadType === LOAD_TYPE.tagsSearchIntoCategory
      || loadType === LOAD_TYPE.tagSearchIntoTag
      || loadType === LOAD_TYPE.tagGlobalSearchIntoTag
    , [loadType]);

  const categoryList = useMemo(() => {
    return isGlobalSearch ? foundCategories : finalCategoryList
  }, [isGlobalSearch, foundCategories, finalCategoryList])

  useEffect(() => {
    if (isGlobalSearch) {
      setCurrentCategory('all');
    }
  }, [isGlobalSearch])

  const onModalClose = (firstTag: Tag): void => {
    if (firstTag) {
      if (firstTag.tagId === AGEYTOMESH_TAG_ID) {
        window.open("https://ageytomesh.com")
      } else if (firstTag.link) {
        window.open(`${firstTag.link}tag/${firstTag?.tagId}`)
      } else {
        history.push(
          isLaboratoryPage ?
            CreateLinkTo.tag(firstTag?.tagId) + LABORATORY_PARAM + '&' + APPROVED_HSEDESIGN_PARAM?.slice(1) :
            isHSEdesign ?
              CreateLinkTo.tag(firstTag?.tagId) + APPROVED_HSEDESIGN_PARAM :
              CreateLinkTo.tag(firstTag?.tagId)
        )
      }
      modal.hide();
    }
  };

  const onLangSelect = (lang: string) => {
    SaveUserLang(lang as Parameters<typeof SaveUserLang>[0]);
    setAppLang(lang);
    i18n.changeLanguage(lang).then();
  }

  const groupped: IGrouppedTags<Tag[]> = useMemo(
    () => {
      if (tags && !load) {
        return tags.reduce((result: any, {
          isEducationTag,
          tagId: categoryId,
          isTagCategory,
          isSearchButton,
          isSearchResult,
          name: categoryTitle,
          groupId,
          isEmptyCategory,
          position,
          level,
          entityTypes,
          typeCategory,
          additionalTags,
          isShowAll,
        }: any) => {

          const childrens = tags.map((v: any) => v?.additionalTags);

          if (childrens?.length) {
            return [...result, {
              isEducationTag,
              categoryId,
              groupId,
              categoryTitle,
              isTagCategory,
              isSearchButton,
              isSearchResult,
              isEmptyCategory,
              level,
              position,
              entityTypes,
              typeCategory,
              found: 0,
              childrens: additionalTags,
              isShowAll,
            }]
          }

          return result;


        }, []).map((c: any) => {
          return {
            ...c,
            childrens: setInitialChildrens(c)
          }

        })
      }
    }, [tags, load]);

  // проверка загружаются ли теги в целом
  const [isLoading, setIsLoading] = useState(false);
  useLayoutEffect(() => {
    if (load && (loadType === LOAD_TYPE.tagSearchGlobal || loadType === LOAD_TYPE.initial)) {
      setIsLoading(true);
    }
    if (groupped && !load) {
      setIsLoading(false);
    }

  }, [load, loadType, groupped])

  //@ts-ignore
  const isEmptySearchForAddintTags = useMemo(() => (isEdit && (isGlobalSearch || isLocalSearch) && !load && (!groupped || groupped?.length === 0)), [groupped, isEdit, isGlobalSearch, isLocalSearch, load]);

  //@ts-ignore
  const isGlobalEmptySearch = useMemo(() => (loadType === LOAD_TYPE.tagSearchGlobal && (!groupped || groupped?.length === 0)), [loadType, groupped]);

  const ungrouped: any[] = useMemo(
    () => [
      {
        categoryId: "all",
        categoryTitle: "All",
        tags: (tags ?? []),
        found: 0,
        position: 2,
      }
    ],
    [tags],
  );

  const searchedItems: any = useMemo(() => {
    return (ungroup ? ungrouped : tagsList)
      .map((v) => {
        const raw = !v?.childrens ? [] : [...v?.childrens]

        const filteredChildrens = viewAllTags && isGlobalSearch ? extractTagChilds(v?.tags) : filterChildrens({
          tagsFilter,
          rawChildrens: raw,
          loadType,
          v,
          isEditProjectPage: isEdit || false,
          isTagsSearchPage
        })

        return {
          ...v,
          position: v?.position,
          childrens: filteredChildrens,
          isEmptyCategory: !v?.childrens,
          isShowAll: v.isShowAll,
        }
      })
  }, [ungroup, isGlobalSearch, isTagsSearchPage, viewAllTags, ungrouped, tagsList, tagsFilter, loadType, isEdit]);

  const onSaveTagsByClick = () => {
    onChange && onChange(innerValue)
    modal.hide();
  }

  const setInnerValue = useCallback((arr?: Tag[]) => {
    const placesTagCount = arr?.filter((i) => i?.entityTypes?.includes('places') || i?.entityTypes?.includes('geotag') || i?.entityTypes?.includes('cities'))?.length;
    // @ts-ignore
    const currentTagsCount = arr?.length - placesTagCount;

    if (maxTeamsTags && (currentTagsCount > maxTeamsTags)) {
      toasts.error(t('project_edit.max_team_project_tags_error', { count: maxTeamsTags }));
      // @ts-ignore
      setInnerValueFinal(arr.slice(0, arr?.length - 1))
      return;
    }

    if (maxProjectTags && (currentTagsCount > maxProjectTags)) {
      toasts.error(t('project_edit.max_project_tags_error', { count: maxProjectTags }));
      // @ts-ignore
      setInnerValueFinal(arr.slice(0, arr?.length - 1))
      return;
    }
    // @ts-ignore
    if (maxPlacesTags && (placesTagCount > maxPlacesTags)) {
      toasts.error(t('project_edit.max_places_tags_error', { count: maxPlacesTags }));
      // @ts-ignore
      setInnerValueFinal(arr.slice(0, arr?.length - 1))
      return;
    }
    if (!saveOnClick) {
      // @ts-ignore
      onChange?.(arr);
    }
    // @ts-ignore
    setInnerValueFinal(arr)
    // @ts-ignore
    valueRef.current = arr;
    return;
  }, [maxProjectTags, saveOnClick, maxPlacesTags, onChange, toasts, maxTeamsTags, t])

  useEffect(() => {
    return () => {
      onClose?.(valueRef.current);
    };
  }, []);


  useEffect(() => {
    if (newTag?.tagId) {
      setInnerValue([...innerValue, newTag])
      dispatch(TagsActions.setNewTag(null))
    }
  }, [dispatch, newTag])

  useEffect(() => {
    const currentInnerValue = innerValue.map(x => x.tagId);
    if (currentInnerValue?.length) {
      setInnerLocalValue(innerValue)
      API.request()
        .endpoint(Endpoints.tagsMnePw)
        .url('/api/Tags/GetTags')
        .addQuery('tagIds', currentInnerValue)
        .lang(i18n.language)
        .send()
        .then((v) => v.json())
        .then((v: any) => {
          setInnerLocalValue(currentInnerValue.map(x => v.find((y: any) => y.tagId === x)))
        });
    } else {
      setInnerLocalValue([]);
    }
  }, [innerValue])

  const innerLocalValue = useMemo(() => {
    return API.toLang(innerLocalValueRaw, i18n.language)
  }, [innerLocalValueRaw, i18n.language])

  const categoryVisible = useMemo(
    () => (!(viewAllTags || (isTagAdminPage && isGlobalSearch && searchedItems?.length === 0 && !!searchText?.length)) && !isCreateLocation) 
  , [viewAllTags, searchedItems, isGlobalSearch, isTagAdminPage, isCreateLocation])

  const getTagsByIds = (ids: string[], tags: Tag[]): Tag[] => {
    var result: Tag[] = [];
    var tagsTems = tags.filter(x => ids.some(y => y === x.tagId));
    if (tagsTems.length > 0) {
      result.push(...tagsTems);
    }
    tags.forEach(x => {
      if (x.additionalTags.length > 0) {
        const additionalTags = getTagsByIds(ids, x.additionalTags);
        if (additionalTags.length > 0) {
          result.push(...additionalTags);
        }
      }
    });
    return result;
  };

  /**
   * Управляющая констукция
   */
  useEffect(() => {
    if (groupped && !load) {
      if (loadType === LOAD_TYPE.initial || loadType === LOAD_TYPE.tagSearchGlobal) {
        dispatch(TagsActions.setTags(groupped))
        setIsLoading(false)
      }
      //@ts-ignore
      if ((loadType === LOAD_TYPE.tagSearch || loadType === LOAD_TYPE.update) && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getUpdated(tagsList, groupped)))
      }
      //@ts-ignore
      if (loadType === LOAD_TYPE.tagsSearchIntoCategory && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getUpdated(tagsList, groupped, 'isSearchIntoCategory')))
      }
      //@ts-ignore
      if (loadType === LOAD_TYPE.tagsSearchIntoCategory && groupped?.length > 1) {
        dispatch(TagsActions.updateTags(groupped));
      }
      //@ts-ignore
      if (loadType === LOAD_TYPE.tagSearchIntoTag && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getUpdated(tagsList, groupped)))
      }
      //@ts-ignore
      if (loadType === LOAD_TYPE.tagGlobalSearchIntoTag && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getUpdated(tagsList, groupped)))
      }
      //@ts-ignore
      if ((loadType === LOAD_TYPE.tagsFetchMore || loadType === LOAD_TYPE.test) && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getSearched(tagsList, groupped)))
      }
      //@ts-ignore
      if (loadType === LOAD_TYPE.tagsFetchMoreLarge && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getSearched(tagsList, groupped, LOAD_TYPE.tagsFetchMoreLarge)))
      }
      //@ts-ignore
      if (loadType === LOAD_TYPE.tagsFetchMoreLargeChild && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getSearched(tagsList, groupped)))
      }
      if (loadType === LOAD_TYPE.updateLang) {
        setLoadType(LOAD_TYPE.initial);
      }
    }
  }, [groupped, load, loadType, dispatch, i18n])

  useEffect(() => {
    if (mainSearchRef) {
      mainSearchRef.current?.focus()
    }
  }, [mainSearchRef])


  useEffect(() => {
    if (innerValue && !!innerValue.length && mode === 'link') {
      onModalClose(innerValue[0])
    }
  }, [innerValue, onModalClose, mode])

  const onInputText = (e: any) => {
    const str = e.target.value.trim();
    if (str && str.length > 1) {
      const { hasEduTags, ...filteredInitialTagsFilter } = initialTagsFilter;
      setTagsFilter({
        search: [e.target.value],
        ...filteredInitialTagsFilter,
        ...(!!isViewAllTagsMode ? {} : {
          groupIds: [],
          ...(hasEduTags !== undefined ? {isEducation: undefined} : {}),
        })
      })
      setLoadType(LOAD_TYPE.tagSearchGlobal)
      setSearchText(str)
      setTime(Date.now())
    }
    if (str === '') {
      setInitialSearchParam(null)
      setTagsFilter({
        ...initialTagsFilter,
      })
      setSearchText('')
      onToggleActiveTag(null)
      setLoadType(LOAD_TYPE.initial)
      setTime(Date.now())
    }
  };

  const handleSearchIntoTagChange = useCallback((e: any, id: string, loadT?: number) => {
    const isCategorySearch = loadT && [LOAD_TYPE.tagsSearchIntoCategory].includes(loadT);
    const isGlobalSearchIntoTag = loadT && [LOAD_TYPE.tagGlobalSearchIntoTag, LOAD_TYPE.tagSearchIntoTag].includes(loadT);
    const entityFilter = !isGlobalSearchIntoTag && { isHeaderIgnored: !!searchText }

    const str = e.target.value.trim();

    if ((str && str.length > 0) || (!isCategorySearch && !isGlobalSearchIntoTag)) {
      const { hasEduTags, ...filteredOptionTagsFilter } = optionTagsFilter;
      setTagsFilter({
        groupIds: [id],
        search: [str],
        status: [0],
        isHeaderIgnored: true,
        ...filteredOptionTagsFilter,
        ...(isCreateLocation ? { entityTypes: [] } : {})
      })
      setLoadType(loadT || LOAD_TYPE.tagSearch)
    }

    if (str === '' && isCategorySearch) {
      setTagsFilter({
        ...initialTagsFilter,
        groupIds: [id],
        ...(isCreateLocation ? { entityTypes: [] } : {})
      })
      setLoadType(LOAD_TYPE.initial)
    }

    if (str === '' && isGlobalSearchIntoTag) {
      setTagsFilter({
        ...entityFilter,
        ...optionTagsFilter,
        status: [0],
        isHeaderIgnored: true,
      })

      setLoadType(loadT || LOAD_TYPE.tagSearch)
    }

    setTime(Date.now())

  }, [initialTagsFilter, optionTagsFilter, isCreateLocation])


  const handleCategoryHover = useCallback((tagId: string) => {
    if (tagId === 'all') {
      const { hasEduTags, ...filteredOptionTagsFilter } = optionTagsFilter;

      setTagsFilter({
        // @ts-ignore
        search: searchText,
        status: [0],
        isHeaderIgnored: global,
        groupIds: [],
        ...filteredOptionTagsFilter,
        ...(hasEduTags !== undefined ? {isEducation: undefined} : {})
      })
      setLoadType(LOAD_TYPE.tagSearchGlobal)
    } else {
      setTagsFilter({
        groupIds: [tagId],
        status: [0],
        isHeaderIgnored: global,
        ...optionTagsFilter
      })
      setLoadType(LOAD_TYPE.tagsSearchIntoCategory)
    }
    setCurrentCategory(tagId);
    setTime(Date.now())
  }, [tagsList, setTagsFilter, setLoadType, setTime, searchText, optionTagsFilter])

  useEffect(() => {
    // @ts-ignore
    tagSearchListRef.current?.scrollTo(0, 0);
  }, [currentCategory])

  const onToggleActiveTag = (id: string | null) => {
    if (activeTag.current === id) {
      activeTag.current = null;
    } else {
      activeTag.current = id;
    }
  }

  const handleToggleChildrenClick = useCallback((id: string) => {
    const changed = tagsList.map((c) => {
      //@ts-ignore
      const iend = c?.childrens?.filter((k: Tag) => k?.tagId === id)[0];

      if (iend && iend?.level === 1 && iend?.additionalTags?.length === 0) {
        setTagsFilter({
          groupIds: [iend?.tagId],
          status: [0],
          ...optionTagsFilter,
        })
        setLoadType(LOAD_TYPE.update)
        setTime(Date.now())
      }
      
      return c;
    })

    dispatch(TagsActions.setTags(changed))
    onToggleActiveTag(id)
  }, [tagsList, dispatch, optionTagsFilter])

  const handleSetUrlClick = useCallback((id: string): void => {
    if (id) {
      if (isLaboratoryPage) {
        history.push(CreateLinkTo.tag(id + `/${LABORATORY_PARAM}&${APPROVED_HSEDESIGN_PARAM.slice(1)}`))
      } else if (isHSEdesign) {
        history.push(CreateLinkTo.tag(id + '/' + APPROVED_HSEDESIGN_PARAM))
      } else {
        history.push(CreateLinkTo.tag(id))
      }
      modal.hide();
    }
  }, [isLaboratoryPage, isHSEdesign, history, modal])

  const handleMoreClick = useCallback((id: string, loadT?: number) => {
    setTagsFilter({
      groupIds: [id],
      status: [0],
      isHeaderIgnored: true,
      ...optionTagsFilter
    })

    setTime(Date.now())
    setLoadType(loadT || LOAD_TYPE.update)
  }, [])

  const foundTagsRef = useRef<HTMLDivElement>(null);
  const [resultTagsHeight, setResultTagsHeight] = useState(is992 ? 170 : 380);

  const graveStyle = {
      fontFamily: 'Inter',
      fontWeight: 400,
      padding: '2px 8px 4px 8px', 
      fontSize: '11px', 
      lineHeight: '13px', 
      letterSpacing: '-0.02em',
      color: '#fff',
      backgroundColor: '#2C2C2B',
      background: '#2C2C2B',
      textColor: '#fff',
      id: 'tooltip-parent-element',
      className: 'tooltip-parent-element',
    }
    const tooltipStyles = (!isCGRAVE && !isContinuumSite) ? getTooltipStyles(theme) : graveStyle

  const currentCategoryName = useMemo(() => {
    return categoryList?.find((c) => c?.tagId === currentCategory)?.name || ''
  }, [categoryList, currentCategory])

  useEffect(() => {

    const resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        setResultTagsHeight(entry.target.getBoundingClientRect().height + (isLinkMode ? (is992 ? 200 : 250) : (is992 ? 144 : 353)))
      }
    })

    if (foundTagsRef?.current) {
      resizeObserver.observe(foundTagsRef?.current)
    }

    return () => {
      if (foundTagsRef?.current) {
        resizeObserver.unobserve(foundTagsRef?.current)
      }
    }
  }, [is992])

  if (isCreateMode) {
    return (
      <CreateTagComponent 
        onClose={() => setIsCreateMode(false)} 
        onCreateTag={onAfterTagCreate} 
      />
    )
  }

  return (
    <TagsSearchModalWrapper>
      {!isLinkMode && !is992 && (
        <LangSelectHolder>
          <BLangSwitcher
            currentLanguage={i18n.language}
            onLangSelect={onLangSelect}
            key="lang"
          />
        </LangSelectHolder>
      )}
      <TagsSearchModalContainer isMobileMenu={isMobileMenu}>
        {!isLinkMode && saveOnClick && (
          <TitleContainer>
            <TagsSearchTitle color={theme.tagSearch.titleColor}>
              {t(mode === 'link' ? 'select_single' : requiredTags ? 'select_required' : 'select')}
            </TagsSearchTitle>
            <SubmitButton className='select-tags-modal--save-button' onClick={onSaveTagsByClick}>{t('save_tag')}</SubmitButton>
          </TitleContainer>
        )}
        {!isLinkMode && !saveOnClick && (
          <TagsSearchTitle color={theme.tagSearch.titleColor}>
            {t(isTagEditor ? 'tag_editor' : mode === 'link' ? 'select_single' : requiredTags ? 'select_required' : 'select')}
          </TagsSearchTitle>
        )}
        {!hideGlobalSearchBar && !(isHseSpace && isCompetencies) && (
          <TagsSearchInputWrapper
            isCGRAVE={isCGRAVE || isContinuumSite}
            offsetTop={(is992 && isMobileMenu) ? 20 : isLinkMode ? 0 : (is992 ? 16 : 48)}
            isMobileMenu={is992 && isMobileMenu}
            gx={12}
          >
            <SearchIcon fill={theme.tags.modal.search.color}/>
            <TagsSearchInput
              ref={mainSearchRef}
              onInput={debounceEvent(onInputText, 1000)}
              placeholder={t('tags_modal.search_mobile')}
            />
          </TagsSearchInputWrapper>
        )}
        {(!isMobile && !isGlobalEmptySearch) && (
          <TagsSearchSelection
            ref={foundTagsRef}
            style={{
              display: 'flex',
              flexFlow: 'row',
              margin: '0',
              paddingTop: innerValue.length > 0 ? '24px' : '8px',
              paddingBottom: innerValue.length > 0 ? '14px' : 0,
            }}>
            {!isLinkMode && !!innerValue.length && (
              <TagsSelectedTitle
                style={{ display: 'inline-flex', placeItems: 'center', whiteSpace: 'nowrap' }}
              >
                {(!!innerValue.length && mode !== 'link') ? (isTagEditor ? `${t('tags_in_project')}:` : `${t('tags_modal.selected_tags')}:`) : t('tags_modal.select_tags')}
              </TagsSelectedTitle>
            )}
            {
              // @ts-ignore
              !!innerLocalValue.length && (
                <BTagsGridNew className='selected-tags-grid'>
                  {mode !== 'link' &&
                  // @ts-ignore
                  innerLocalValue.map((v: any) => (
                    <BTag
                      tag={v}
                      removable={true}
                      key={v.tagId}
                      educational={isRequired(v)}
                      organization={v?.isTeamTag}
                      showRemoveIcon={!(isTagEditor && !editableTags.includes(v.tagId) && !(bProfile.isModer(profile) || bProfile.isSuperModer(profile)))}
                      disabled={!!isTagEditor && !editableTags.includes(v.tagId) && !(bProfile.isModer(profile) || bProfile.isSuperModer(profile))}
                      onIconClick={() => {
                        if (isTagEditor && !editableTags.includes(v.tagId) && !(bProfile.isModer(profile) || bProfile.isSuperModer(profile))) {
                            return;
                        }
                        if (protectedTags.includes(v.tagId)) {
                          toasts.error('Это обязательный тег');
                        } else {
                          const vi = innerValue.filter((t) => t.tagId !== v.tagId);
                          ReactTooltip.hide()
                          setInnerValue(vi);
                        }
                      }}
                    >
                      {bTag.title(v)}
                    </BTag>
                  ))}
                </BTagsGridNew>
              )}
          </TagsSearchSelection>
        )}
          {isTagEditor &&
              <TagsAvailableTitle
              style={{ display: 'inline-flex', placeItems: 'center', whiteSpace: 'nowrap' }}
          >
            {t('available_tags_in_project')}
          </TagsAvailableTitle>}
        <TagsSearchResultsWrapper
            direction={isViewAllTagsMode ? 'column' : 'row'}
            gx={is992 ? 16 : 24}
            offsetTop={!!innerValue?.length ? 16 : 22}
            shadowColor={theme.app.backgroundColor}
        >
          {isGlobalEmptySearch && !isLoading && (
            <EmptyTextWrapper direction="column" gy={24} isIqMediia={isIqMediia} width="100%" align="center" justify="center">
              <EmptyText>{t("tags_modal.empty_search")}</EmptyText>
              {(isTagAdminPage || viewAllTags) && <CreateTagButton onClick={() => setIsCreateMode(true)}>{t("tags_modal.create_tag")}</CreateTagButton>}
            </EmptyTextWrapper>
          )}
          {categoryVisible && !isGlobalEmptySearch && (
              <>
                <CategoryList
                    tags={categoryList}
                    // @ts-ignore
                    onHover={handleCategoryHover}
                    currentCategory={currentCategory}
                    customHeight={is992 ? 330 : resultTagsHeight}
                    isClickable={isLinkMode}
                    setHideMore={setHideMore}
                />
                {is992 && <ModalContextSplitLine/>}
              </>
          )}
          {isLoading && (
            <FlexBox justify="center" width='100%' style={{ height: resultTagsHeight }}>
              <LoaderSpinner color={theme.selectContextModal.loaderText} text={t('project_edit.modal.load_msg_tag')}/>
            </FlexBox>
          )}
          {!isLoading && (
            <TagsSearchResults
              customHeight={resultTagsHeight}
              direction={'column'}
              directionMobile={"column"}
              width={'100%'}
              // @ts-ignore
              ref={tagSearchListRef}
            >
              <TagsSearchResultsContext
                  direction={'column'}
                  directionMobile={'column'}
                  width={'100%'}
                  isGlobalSearch={isGlobalSearch}
              >
                <BTagsGridNew
                    style={{
                      position: 'relative',
                      height: 'auto',
                      paddingBottom: '10px'
                    }}
                    noLimitMaxHeight
                >
                  {<TabletTitle
                      onClick={() => {
                        if (!is992) return;
                        history.push(CreateLinkTo.tag(currentCategory || ''));
                      }}
                      width='100%' gx={8} offsetBottom={is992 ? 14 : 4} align="center"><span>{currentCategoryName}</span>{is992 && <ArrowTopRightIcon/>}</TabletTitle>}
                  {searchedItems
                    .map((g: any) => {
                      const items = isViewAllTagsMode ? g?.tags : g?.childrens;
                      return (
                        <TagsSearchResultsItem
                          hideMore={hideMore}
                          setHideMore={setHideMore}
                          isViewAllTagsMode={viewAllTags}
                          search={searchText}
                          key={g?.categoryId}
                          activeTagId={activeTag.current || ''}
                          title={g?.categoryTitle}
                          identifier={g?.categoryId}
                          items={items}
                          found={g?.found}
                          isCategorySearchNeed={g?.isSearchButton}
                          searchingIntoTag={isLocalSearch}
                          isSelected={(id) => innerValue.some((v) => v?.tagId === id)}
                          isCategoryTag={g?.isTagCategory}
                          onClick={(tag: any, selected) => {
                            let v = innerValue;
                            if (!selected) {
                              const educationalTags = innerValue.filter(({ isEducationTag }: any) => isEducationTag);

                              if (maxEducationalTags !== undefined && tag?.isEducationTag && educationalTags?.length + 1 > maxEducationalTags) {
                                toasts.error(maxEducationalTags > 1
                                  ? t('project_edit.max_education_tags_error', { count: maxEducationalTags })
                                  : t('project_edit.max_required_tags_error'))
                              } else {
                                v = mode === 'link' || (max && innerValue?.length + 1 > max) ? [tag] : [...innerValue, tag];
                              }
                            } else if (protectedTags.includes(tag?.tagId)) {
                              toasts.error('Это обязательный тег');
                              return;
                            } else {
                              v = innerValue.filter((t) => t.tagId !== tag.tagId);
                            }
                            setInnerValue(v);
                          }}
                          onTagArrowClick={handleToggleChildrenClick}
                          onParentClick={handleSetUrlClick}
                          onMoreClick={handleMoreClick}
                          onSearchInputChange={(e) => handleSearchIntoTagChange(e, g?.categoryId, LOAD_TYPE.tagsSearchIntoCategory)}
                          onSearchIntoCategory={(e) => handleSearchIntoTagChange(e, g?.categoryId, LOAD_TYPE.tagsSearchIntoCategory)}
                          setIsOpenTag={setIsOpenTag}
                          isEditPage={isEdit || isCreateLocationPage}
                          loadType={loadType}
                          isEmptySearch={isEmptySearchForAddintTags}
                          tagsFilter={tagsFilter}
                          setTime={setTime}
                          isGlobalSearch={isGlobalSearch}
                          isShowAll={g.isShowAll}
                          isLinkMode={isLinkMode}
                          isCreateLocationPage={isCreateLocationPage}
                        />
                      );
                    })}
                  <ReactTooltip  {...tooltipStyles}/>
                </BTagsGridNew>
              </TagsSearchResultsContext>
              {isViewAllTagsMode && (
                <SimplePagination 
                  page={Number(page || 1)} 
                  //@ts-ignore
                  pages={parseFloat((tagsAllRu?.count / ALL_TAGS_LIMIT).toFixed())} 
                  onPageChange={handlePageChange} 
                  disableOffset
                />
              )}
            </TagsSearchResults>
          )}
        </TagsSearchResultsWrapper>
      </TagsSearchModalContainer>
      <ReactTooltip/>
    </TagsSearchModalWrapper>
  );
};
import { FC, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import ReactTooltip from "react-tooltip";
import { useToasts, FlexBox, BLangSwitcher, useBreakpoint } from '@brg/ui';
import { API, Endpoints, Tag } from '@brg/api';
import {
  TagsAvailableTitle,
  ModalContextSplitLine, TabletTitle,
  TagsSearchInput,
  TagsSearchInputWrapper,
  TagsSearchModalContainer,
  TagsSearchModalWrapper,
  TagsSearchResults,
  TagsSearchResultsContext,
  TagsSearchSelection,
  TagsSearchTitle,
  TagsSelectedTitle,
  SubmitButton,
  LangSelectHolder,
  TagsSearchResultsWrapper,
  TitleContainer,
} from './styles';
import { TagsSearchResultsItem } from './tagsSearchResultsItem';
import { BTag } from '../../../core/components';
import { bTag, LayoutConst, useModal } from '../../../core';
import { ITagsProps } from 'shared/hooks/api/useTagsList';
import { EmptyText, EmptyTextWrapper } from './FoundTags';
import { debounceEvent } from 'shared/utils/debounce';
import { useDispatch, useSelector } from 'react-redux';
import { TagsActions, TagsSelector } from 'shared/reducers/Tags';
import { ArrowTopRightIcon, SearchIcon } from 'shared/icons';
import { CreateLinkTo } from 'shared/constants/linkTo';
import { AGEYTOMESH_TAG_ID } from 'shared/constants/misc';
import { getSearched, getUpdated } from './support/updateTag';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { filterChildrens } from './support/filterChildrens';
import { AppTester } from 'supporting';
import { SaveUserLang } from "../../components/__ADDONS__/__LANG__/Utils/GetUserLang";
import { setAppLang } from "../../components/__ADDONS__/__LANG__/Slice";
import { setInitialChildrens } from './support/setInitialChildrens';
import { useContextsTabs } from 'shared/hooks/useContextsTabs';
import { isRequired } from './support/isRequired';
import { LoaderSpinner } from "../artzLegalsModal/LoaderAnimation";
import CategoryList from "./CategoryList";
import { useGetAllTags } from 'shared/hooks/api/useGetAllTags';
import useQueryState from 'shared/hooks/useQueryState';
import { SimplePagination } from 'shared/components/pagination/SimplePagination';
import { extractTagChilds } from './support/extractTagChilds';
import { removeUndefined } from "../../helpers/removeUndefined";
import { CreateTagButton } from './components/CreateTagComponent/style';
import { CreateTagComponent } from './components/CreateTagComponent/CreateTagComponent';
import { getTooltipStyles } from 'shared/constants/tooptipStyles';
import {BTagsGridNew} from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import {useGetApiTags} from "../../hooks/api/useGetApiTags";
import {bProfile} from "../../../core/utils/bProfile";
import {useProfile} from "@brg/auth";
import { useInitialCategories } from './support/useInitialCategoires';
import { SelectTagsModalProps } from './types';

export interface IGrouppedTags<T> {
  isEducationTag?: boolean;
  categoryId?: string;
  childrens?: T;
  found?: number;
  position?: number;
  groupId?: string | null;
  categoryTitle?: string;
  isTagCategory?: boolean;
  isSearchButton?: boolean;
  isMoreButton?: boolean;
  isEmptyCategory?: boolean;
}

export enum LOAD_TYPE {
  initial = 1,
  update = 2,
  tagSearch = 3,
  tagsSearchIntoCategory = 4,
  tagSearchIntoTag = 5,
  tagGlobalSearchIntoTag = 6,
  tagSearchGlobal = 7,
  tagsFetchMore = 8,
  tagsFetchMoreLarge = 9,
  tagsFetchMoreLargeChild = 10,
  test = 11,
  updateLang = 12
}

export const LABORATORY_PARAM = '?_lab';
export const APPROVED_HSEDESIGN_PARAM = '';
export const REQUIRED_TAG_ID = '390ea8c2329fc0bc9c389a1b0f1f6e4d';
export const EDUCATIONAL_CATEGORY_ID = 'c326e5a4bd0b02c9c338fe382ac1f9a8';
export const ALL_TAGS_LIMIT = 100;


export const SelectTagsModal: FC<SelectTagsModalProps> = (props) => {
  const {
    value, onChange,
    mode,
    ctx,
    isCompetencies,
    max,
    maxProjectTags,
    maxPlacesTags,
    maxTeamsTags,
    onClose,
    onAfterTagCreate,
    hideGlobalSearchBar,
    maxEducationalTags,
    ungroup,
    protectedTags = [],
    editableTags = [],
    requiredTags,
    isTagEditor,
    isMobileMenu,
    isTagAdminPage,
    isEdit,
    educational,
    isCreateLocation,
    global: globalProp,
    hasEduTags,
    saveOnClick = true,
    viewAllTags,
    ignoreHeader,
  } = props;

  const [innerValue, setInnerValueFinal] = useState<Tag[]>(value ?? []);
  const [innerLocalValueRaw, setInnerLocalValue] = useState<Tag[]>([]);
  const location = useLocation();
  const valueRef = useRef<Tag[]>([]);
  const prevLangRef = useRef<string | null>(null);
  const tagSearchListRef = useRef();
  const activeTag = useRef<any>(null)
  const mainSearchRef = useRef<any>(null);
  const toasts = useToasts();
  const dispatch = useDispatch();
  const history = useHistory();
  const isTagsSearchPage = location.pathname.startsWith('/tags');
  const isEditProjectPage = location.pathname.startsWith('/edit');
  const isCreateLocationPage = location.pathname.startsWith('/createLocation');
  const isBrnd = AppTester.isBrnd();
  const isStartHSE = AppTester.isStartHSE();
  const [{ page }, setQueryState ] = useQueryState();

  const [hideMore, setHideMore] = useState(false);

  const isHSEdesign = AppTester.isHSEDesign();
  const isCGRAVE = AppTester.isCGRAVE();
  const isContinuumSite = AppTester.isContinuumSite();
  const isIqMediia = AppTester.isIqMediiia();
  const isHseSpace = AppTester.isHseSpace();
  const isFilmRoute = !!useRouteMatch('/film');
  const isMobile = useBreakpoint(LayoutConst.screen.s);
  const is992 = useBreakpoint(LayoutConst.screen.m);
  const theme = useTheme();
  const modal = useModal();
  const { t, i18n } = useTranslation();
  const [isCreateMode, setIsCreateMode] = useState(false);
  const [foundCategories, setFoundCategories] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchInitialParam, setInitialSearchParam] = useState<any>(null);
  const [currentCategory, setCurrentCategory] = useState<string | null>(null);
  const profile = useProfile()
  const isModer = bProfile.isModer(profile) || bProfile.isSuperModer(profile)
  const global = useMemo(() => ((Boolean(isTagEditor && !isModer && !!editableTags?.length)) || globalProp),
      [isModer, globalProp, isTagEditor])

  const handlePageChange = (p: number ) => {
    setQueryState({ page: p })
    setTime(Date.now());
  }

  const isLinkMode = mode === 'link';

  const optionTagsFilter = useMemo(() => ({
    isModeEditing: isEdit || false,
    ...(isStartHSE && isTagsSearchPage ? {
      isEducation: true,
    } : educational !== undefined ? {
      isEducation: educational,
    } : {}),
    ...(ctx  ? {
      entityTypes: ctx,
    } : {}),
    ...(isTagEditor && !isModer && editableTags ? {
      tagIds: editableTags || [],
    } : {}),
    ...(global ? {
      isHeaderIgnored: global,
    } : {}),
    ...(hasEduTags !== undefined && !(isStartHSE && isTagsSearchPage) ? {
      hasEduTags: hasEduTags,
    } : {}),
    ...(isBrnd && isEdit && ignoreHeader !== false ? {
      isHeaderIgnored: true,
    } : {}),
  }), [isModer, isEdit, educational, isTagEditor, global, ctx, hasEduTags, isStartHSE, isTagsSearchPage])

  useEffect(() => {
    if (
      searchText?.length && 
      isLinkMode && 
      prevLangRef.current && 
      prevLangRef.current !== i18n.language
    ) {
      setInitialSearchParam({ search: [ searchText ] })
    }
    prevLangRef.current = i18n.language
  } , [i18n.language, isLinkMode, searchText, prevLangRef.current])

  const initialTagsFilter = useMemo(() => ({
    ...optionTagsFilter,
    status: [0],
    lang: i18n.language,
    ...(searchInitialParam ? searchInitialParam : {})
  }), [i18n.language, optionTagsFilter, searchInitialParam])


  const appContext = isFilmRoute ? 'filmhsespace' : '';
  
  const initialCategoryList = useInitialCategories(optionTagsFilter);

  const finalCategoryList = useMemo(() => {

    return initialCategoryList
  } , [initialCategoryList])

  const initialAllTagsFilter = useMemo(() => ({
    status: 0,
    level: 1,
    isHeaderIgnored: true,
    includeCount: true,
    limit: ALL_TAGS_LIMIT,
    page: page ? page : 1
  }), [ctx, i18n.language, page, isEditProjectPage])

  const [tagsFilter, setTagsFilterFinal] = useState<ITagsProps>(initialTagsFilter);

  const setTagsFilter = useCallback((filter: ITagsProps) => {
    setTagsFilterFinal({
      ...removeUndefined(filter)
    })
  }, [optionTagsFilter, requiredTags])

  const [loadType, setLoadType] = useState<number>(LOAD_TYPE.initial);
  const [time, setTime] = useState(Date.now());
  const [_, setIsOpenTag] = useState<boolean>(false); /** TODO: почистить и проверить компоненты, в которые пробрасывается сеттер  */

  const isViewAllTagsMode = useMemo(() => {
    return viewAllTags && loadType !== LOAD_TYPE.tagSearchGlobal
  } , [viewAllTags, loadType])

  const requestsDisabled = isViewAllTagsMode || !finalCategoryList?.length || ([LOAD_TYPE.initial, LOAD_TYPE.tagsSearchIntoCategory].includes(loadType) && !tagsFilter?.groupIds);
  const shouldCacheValues = true;

  const [tagsEn, loadEn] = useGetApiTags({
    ...tagsFilter,
    lang: 'en',
  }, 'en', time, requestsDisabled, appContext);
  const [tagsRu, loadRu] = useGetApiTags({
    ...tagsFilter,
    lang: 'ru',
  }, 'ru', time, requestsDisabled, appContext);

  //@ts-ignore
  const [tagsAllEn, loadAllEn] = useGetAllTags({ ...initialAllTagsFilter }, 'en', time, !isViewAllTagsMode, shouldCacheValues);
  //@ts-ignore
  const [tagsAllRu, loadAllRu] = useGetAllTags({ ...initialAllTagsFilter }, 'ru', time, !isViewAllTagsMode, shouldCacheValues);

  const load = isViewAllTagsMode ? (loadAllEn || loadAllRu) : (loadEn || loadRu);

  const tags = useMemo(() => {
    if (i18n.language === 'ru') {
      //@ts-ignore
      return isViewAllTagsMode ? tagsAllRu?.data : tagsRu;
    }
    //@ts-ignore
    return isViewAllTagsMode ? tagsAllEn?.data : tagsEn;
  }, [i18n.language, tagsEn, tagsAllRu, tagsAllEn, tagsRu, isViewAllTagsMode]);

  useEffect(() => {
    if (finalCategoryList?.length) {
      setTagsFilter({
        ...initialTagsFilter,
        groupIds: [finalCategoryList[0]?.tagId],
        ...(isCreateLocation ? { entityTypes: [] } : {})
      })
      setTime(Date.now());
      setCurrentCategory(finalCategoryList[0]?.tagId);
    }
  }, [finalCategoryList, isCreateLocation, initialTagsFilter])

  useEffect(() => {
    if (!currentCategory && !isViewAllTagsMode) {
      setCurrentCategory(tags[0]?.tagId)
    }
  }, [tags, isViewAllTagsMode])

  useEffect(() => {
    if (loadType !== LOAD_TYPE.tagsSearchIntoCategory) {
        // @ts-ignore
      const categories = tags?.filter((tag) => tag.isSearchResult) || []
      const ALL = {
        tagId: 'all',
        title: 'все',
        name: 'все',
        level: 2,
      }
      // @ts-ignore
      setFoundCategories([ALL, ...categories]);
    }
  }, [tags])

  const { tagsList, newTag } = useSelector(TagsSelector);

  const isLaboratoryPage = window?.location.pathname.startsWith('/laboratory') || Boolean(window.location.href.split('?').find((l) => l === LABORATORY_PARAM.slice(1)));

  const isGlobalSearch = useMemo(
    () =>
      searchText.length > 0 &&
      (loadType === LOAD_TYPE.tagSearchGlobal
        || loadType === LOAD_TYPE.tagsFetchMore
        || loadType === LOAD_TYPE.tagsFetchMoreLarge
        || loadType === LOAD_TYPE.tagsFetchMoreLargeChild
        || loadType === LOAD_TYPE.tagSearch
        || loadType === LOAD_TYPE.tagSearchIntoTag
        || loadType === LOAD_TYPE.tagGlobalSearchIntoTag
        || loadType === LOAD_TYPE.tagsSearchIntoCategory
        || loadType === LOAD_TYPE.test
        || loadType === LOAD_TYPE.update)
    , [searchText, loadType]);

  useEffect(() => {
    if (!searchText.length && !!finalCategoryList?.length) {
      const category = finalCategoryList[0]?.tagId;
      setLoadType(LOAD_TYPE.tagsSearchIntoCategory);
      setCurrentCategory(category);
      setTagsFilter({
        ...initialTagsFilter,
        groupIds: [category],
        ...(isCreateLocation ? { entityTypes: [] } : {})
      })
    }
  }, [searchText, initialTagsFilter, isCreateLocation])

  const isLocalSearch = useMemo(
    () =>
      loadType === LOAD_TYPE.tagSearch
      || loadType === LOAD_TYPE.tagsSearchIntoCategory
      || loadType === LOAD_TYPE.tagSearchIntoTag
      || loadType === LOAD_TYPE.tagGlobalSearchIntoTag
    , [loadType]);

  const categoryList = useMemo(() => {
    return isGlobalSearch ? foundCategories : finalCategoryList
  }, [isGlobalSearch, foundCategories, finalCategoryList])

  useEffect(() => {
    if (isGlobalSearch) {
      setCurrentCategory('all');
    }
  }, [isGlobalSearch])

  const onModalClose = (firstTag: Tag): void => {
    if (firstTag) {
      if (firstTag.tagId === AGEYTOMESH_TAG_ID) {
        window.open("https://ageytomesh.com")
      } else if (firstTag.link) {
        window.open(`${firstTag.link}tag/${firstTag?.tagId}`)
      } else {
        history.push(
          isLaboratoryPage ?
            CreateLinkTo.tag(firstTag?.tagId) + LABORATORY_PARAM + '&' + APPROVED_HSEDESIGN_PARAM?.slice(1) :
            isHSEdesign ?
              CreateLinkTo.tag(firstTag?.tagId) + APPROVED_HSEDESIGN_PARAM :
              CreateLinkTo.tag(firstTag?.tagId)
        )
      }
      modal.hide();
    }
  };

  const onLangSelect = (lang: string) => {
    SaveUserLang(lang as Parameters<typeof SaveUserLang>[0]);
    setAppLang(lang);
    i18n.changeLanguage(lang).then();
  }

  const groupped: IGrouppedTags<Tag[]> = useMemo(
    () => {
      if (tags && !load) {
        return tags.reduce((result: any, {
          isEducationTag,
          tagId: categoryId,
          isTagCategory,
          isSearchButton,
          isSearchResult,
          name: categoryTitle,
          groupId,
          isEmptyCategory,
          position,
          level,
          entityTypes,
          typeCategory,
          additionalTags,
          isShowAll,
        }: any) => {

          const childrens = tags.map((v: any) => v?.additionalTags);

          if (childrens?.length) {
            return [...result, {
              isEducationTag,
              categoryId,
              groupId,
              categoryTitle,
              isTagCategory,
              isSearchButton,
              isSearchResult,
              isEmptyCategory,
              level,
              position,
              entityTypes,
              typeCategory,
              found: 0,
              childrens: additionalTags,
              isShowAll,
            }]
          }

          return result;


        }, []).map((c: any) => {
          return {
            ...c,
            childrens: setInitialChildrens(c)
          }

        })
      }
    }, [tags, load]);

  // проверка загружаются ли теги в целом
  const [isLoading, setIsLoading] = useState(false);
  useLayoutEffect(() => {
    if (load && (loadType === LOAD_TYPE.tagSearchGlobal || loadType === LOAD_TYPE.initial)) {
      setIsLoading(true);
    }
    if (groupped && !load) {
      setIsLoading(false);
    }

  }, [load, loadType, groupped])

  //@ts-ignore
  const isEmptySearchForAddintTags = useMemo(() => (isEdit && (isGlobalSearch || isLocalSearch) && !load && (!groupped || groupped?.length === 0)), [groupped, isEdit, isGlobalSearch, isLocalSearch, load]);

  //@ts-ignore
  const isGlobalEmptySearch = useMemo(() => (loadType === LOAD_TYPE.tagSearchGlobal && (!groupped || groupped?.length === 0)), [loadType, groupped]);

  const ungrouped: any[] = useMemo(
    () => [
      {
        categoryId: "all",
        categoryTitle: "All",
        tags: (tags ?? []),
        found: 0,
        position: 2,
      }
    ],
    [tags],
  );

  const searchedItems: any = useMemo(() => {
    return (ungroup ? ungrouped : tagsList)
      .map((v) => {
        const raw = !v?.childrens ? [] : [...v?.childrens]

        const filteredChildrens = viewAllTags && isGlobalSearch ? extractTagChilds(v?.tags) : filterChildrens({
          tagsFilter,
          rawChildrens: raw,
          loadType,
          v,
          isEditProjectPage: isEdit || false,
          isTagsSearchPage
        })

        return {
          ...v,
          position: v?.position,
          childrens: filteredChildrens,
          isEmptyCategory: !v?.childrens,
          isShowAll: v.isShowAll,
        }
      })
  }, [ungroup, isGlobalSearch, isTagsSearchPage, viewAllTags, ungrouped, tagsList, tagsFilter, loadType, isEdit]);

  const onSaveTagsByClick = () => {
    onChange && onChange(innerValue)
    modal.hide();
  }

  const setInnerValue = useCallback((arr?: Tag[]) => {
    const placesTagCount = arr?.filter((i) => i?.entityTypes?.includes('places') || i?.entityTypes?.includes('geotag') || i?.entityTypes?.includes('cities'))?.length;
    // @ts-ignore
    const currentTagsCount = arr?.length - placesTagCount;

    if (maxTeamsTags && (currentTagsCount > maxTeamsTags)) {
      toasts.error(t('project_edit.max_team_project_tags_error', { count: maxTeamsTags }));
      // @ts-ignore
      setInnerValueFinal(arr.slice(0, arr?.length - 1))
      return;
    }

    if (maxProjectTags && (currentTagsCount > maxProjectTags)) {
      toasts.error(t('project_edit.max_project_tags_error', { count: maxProjectTags }));
      // @ts-ignore
      setInnerValueFinal(arr.slice(0, arr?.length - 1))
      return;
    }
    // @ts-ignore
    if (maxPlacesTags && (placesTagCount > maxPlacesTags)) {
      toasts.error(t('project_edit.max_places_tags_error', { count: maxPlacesTags }));
      // @ts-ignore
      setInnerValueFinal(arr.slice(0, arr?.length - 1))
      return;
    }
    if (!saveOnClick) {
      // @ts-ignore
      onChange?.(arr);
    }
    // @ts-ignore
    setInnerValueFinal(arr)
    // @ts-ignore
    valueRef.current = arr;
    return;
  }, [maxProjectTags, saveOnClick, maxPlacesTags, onChange, toasts, maxTeamsTags, t])

  useEffect(() => {
    return () => {
      onClose?.(valueRef.current);
    };
  }, []);


  useEffect(() => {
    if (newTag?.tagId) {
      setInnerValue([...innerValue, newTag])
      dispatch(TagsActions.setNewTag(null))
    }
  }, [dispatch, newTag])

  useEffect(() => {
    const currentInnerValue = innerValue.map(x => x.tagId);
    if (currentInnerValue?.length) {
      setInnerLocalValue(innerValue)
      API.request()
        .endpoint(Endpoints.tagsMnePw)
        .url('/api/Tags/GetTags')
        .addQuery('tagIds', currentInnerValue)
        .lang(i18n.language)
        .send()
        .then((v) => v.json())
        .then((v: any) => {
          setInnerLocalValue(currentInnerValue.map(x => v.find((y: any) => y.tagId === x)))
        });
    } else {
      setInnerLocalValue([]);
    }
  }, [innerValue])

  const innerLocalValue = useMemo(() => {
    return API.toLang(innerLocalValueRaw, i18n.language)
  }, [innerLocalValueRaw, i18n.language])

  const categoryVisible = useMemo(
    () => (!(viewAllTags || (isTagAdminPage && isGlobalSearch && searchedItems?.length === 0 && !!searchText?.length)) && !isCreateLocation) 
  , [viewAllTags, searchedItems, isGlobalSearch, isTagAdminPage, isCreateLocation])

  const getTagsByIds = (ids: string[], tags: Tag[]): Tag[] => {
    var result: Tag[] = [];
    var tagsTems = tags.filter(x => ids.some(y => y === x.tagId));
    if (tagsTems.length > 0) {
      result.push(...tagsTems);
    }
    tags.forEach(x => {
      if (x.additionalTags.length > 0) {
        const additionalTags = getTagsByIds(ids, x.additionalTags);
        if (additionalTags.length > 0) {
          result.push(...additionalTags);
        }
      }
    });
    return result;
  };

  /**
   * Управляющая констукция
   */
  useEffect(() => {
    if (groupped && !load) {
      if (loadType === LOAD_TYPE.initial || loadType === LOAD_TYPE.tagSearchGlobal) {
        dispatch(TagsActions.setTags(groupped))
        setIsLoading(false)
      }
      //@ts-ignore
      if ((loadType === LOAD_TYPE.tagSearch || loadType === LOAD_TYPE.update) && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getUpdated(tagsList, groupped)))
      }
      //@ts-ignore
      if (loadType === LOAD_TYPE.tagsSearchIntoCategory && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getUpdated(tagsList, groupped, 'isSearchIntoCategory')))
      }
      //@ts-ignore
      if (loadType === LOAD_TYPE.tagsSearchIntoCategory && groupped?.length > 1) {
        dispatch(TagsActions.updateTags(groupped));
      }
      //@ts-ignore
      if (loadType === LOAD_TYPE.tagSearchIntoTag && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getUpdated(tagsList, groupped)))
      }
      //@ts-ignore
      if (loadType === LOAD_TYPE.tagGlobalSearchIntoTag && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getUpdated(tagsList, groupped)))
      }
      //@ts-ignore
      if ((loadType === LOAD_TYPE.tagsFetchMore || loadType === LOAD_TYPE.test) && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getSearched(tagsList, groupped)))
      }
      //@ts-ignore
      if (loadType === LOAD_TYPE.tagsFetchMoreLarge && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getSearched(tagsList, groupped, LOAD_TYPE.tagsFetchMoreLarge)))
      }
      //@ts-ignore
      if (loadType === LOAD_TYPE.tagsFetchMoreLargeChild && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getSearched(tagsList, groupped)))
      }
      if (loadType === LOAD_TYPE.updateLang) {
        setLoadType(LOAD_TYPE.initial);
      }
    }
  }, [groupped, load, loadType, dispatch, i18n])

  useEffect(() => {
    if (mainSearchRef) {
      mainSearchRef.current?.focus()
    }
  }, [mainSearchRef])


  useEffect(() => {
    if (innerValue && !!innerValue.length && mode === 'link') {
      onModalClose(innerValue[0])
    }
  }, [innerValue, onModalClose, mode])

  const onInputText = (e: any) => {
    const str = e.target.value.trim();
    if (str && str.length > 1) {
      const { hasEduTags, ...filteredInitialTagsFilter } = initialTagsFilter;
      setTagsFilter({
        search: [e.target.value],
        ...filteredInitialTagsFilter,
        ...(!!isViewAllTagsMode ? {} : {
          groupIds: [],
          ...(hasEduTags !== undefined ? {isEducation: undefined} : {}),
        })
      })
      setLoadType(LOAD_TYPE.tagSearchGlobal)
      setSearchText(str)
      setTime(Date.now())
    }
    if (str === '') {
      setInitialSearchParam(null)
      setTagsFilter({
        ...initialTagsFilter,
      })
      setSearchText('')
      onToggleActiveTag(null)
      setLoadType(LOAD_TYPE.initial)
      setTime(Date.now())
    }
  };

  const handleSearchIntoTagChange = useCallback((e: any, id: string, loadT?: number) => {
    const isCategorySearch = loadT && [LOAD_TYPE.tagsSearchIntoCategory].includes(loadT);
    const isGlobalSearchIntoTag = loadT && [LOAD_TYPE.tagGlobalSearchIntoTag, LOAD_TYPE.tagSearchIntoTag].includes(loadT);
    const entityFilter = !isGlobalSearchIntoTag && { isHeaderIgnored: !!searchText }

    const str = e.target.value.trim();

    if ((str && str.length > 0) || (!isCategorySearch && !isGlobalSearchIntoTag)) {
      const { hasEduTags, ...filteredOptionTagsFilter } = optionTagsFilter;
      setTagsFilter({
        groupIds: [id],
        search: [str],
        status: [0],
        isHeaderIgnored: true,
        ...filteredOptionTagsFilter,
        ...(isCreateLocation ? { entityTypes: [] } : {})
      })
      setLoadType(loadT || LOAD_TYPE.tagSearch)
    }

    if (str === '' && isCategorySearch) {
      setTagsFilter({
        ...initialTagsFilter,
        groupIds: [id],
        ...(isCreateLocation ? { entityTypes: [] } : {})
      })
      setLoadType(LOAD_TYPE.initial)
    }

    if (str === '' && isGlobalSearchIntoTag) {
      setTagsFilter({
        ...entityFilter,
        ...optionTagsFilter,
        status: [0],
        isHeaderIgnored: true,
      })

      setLoadType(loadT || LOAD_TYPE.tagSearch)
    }

    setTime(Date.now())

  }, [initialTagsFilter, optionTagsFilter, isCreateLocation])


  const handleCategoryHover = useCallback((tagId: string) => {
    if (tagId === 'all') {
      const { hasEduTags, ...filteredOptionTagsFilter } = optionTagsFilter;

      setTagsFilter({
        // @ts-ignore
        search: searchText,
        status: [0],
        isHeaderIgnored: global,
        groupIds: [],
        ...filteredOptionTagsFilter,
        ...(hasEduTags !== undefined ? {isEducation: undefined} : {})
      })
      setLoadType(LOAD_TYPE.tagSearchGlobal)
    } else {
      setTagsFilter({
        groupIds: [tagId],
        status: [0],
        isHeaderIgnored: global,
        ...optionTagsFilter
      })
      setLoadType(LOAD_TYPE.tagsSearchIntoCategory)
    }
    setCurrentCategory(tagId);
    setTime(Date.now())
  }, [tagsList, setTagsFilter, setLoadType, setTime, searchText, optionTagsFilter])

  useEffect(() => {
    // @ts-ignore
    tagSearchListRef.current?.scrollTo(0, 0);
  }, [currentCategory])

  const onToggleActiveTag = (id: string | null) => {
    if (activeTag.current === id) {
      activeTag.current = null;
    } else {
      activeTag.current = id;
    }
  }

  const handleToggleChildrenClick = useCallback((id: string) => {
    const changed = tagsList.map((c) => {
      //@ts-ignore
      const iend = c?.childrens?.filter((k: Tag) => k?.tagId === id)[0];

      if (iend && iend?.level === 1 && iend?.additionalTags?.length === 0) {
        setTagsFilter({
          groupIds: [iend?.tagId],
          status: [0],
          ...optionTagsFilter,
        })
        setLoadType(LOAD_TYPE.update)
        setTime(Date.now())
      }
      
      return c;
    })

    dispatch(TagsActions.setTags(changed))
    onToggleActiveTag(id)
  }, [tagsList, dispatch, optionTagsFilter])

  const handleSetUrlClick = useCallback((id: string): void => {
    if (id) {
      if (isLaboratoryPage) {
        history.push(CreateLinkTo.tag(id + `/${LABORATORY_PARAM}&${APPROVED_HSEDESIGN_PARAM.slice(1)}`))
      } else if (isHSEdesign) {
        history.push(CreateLinkTo.tag(id + '/' + APPROVED_HSEDESIGN_PARAM))
      } else {
        history.push(CreateLinkTo.tag(id))
      }
      modal.hide();
    }
  }, [isLaboratoryPage, isHSEdesign, history, modal])

  const handleMoreClick = useCallback((id: string, loadT?: number) => {
    setTagsFilter({
      groupIds: [id],
      status: [0],
      isHeaderIgnored: true,
      ...optionTagsFilter
    })

    setTime(Date.now())
    setLoadType(loadT || LOAD_TYPE.update)
  }, [])

  const foundTagsRef = useRef<HTMLDivElement>(null);
  const [resultTagsHeight, setResultTagsHeight] = useState(is992 ? 170 : 380);

  const graveStyle = {
      fontFamily: 'Inter',
      fontWeight: 400,
      padding: '2px 8px 4px 8px', 
      fontSize: '11px', 
      lineHeight: '13px', 
      letterSpacing: '-0.02em',
      color: '#fff',
      backgroundColor: '#2C2C2B',
      background: '#2C2C2B',
      textColor: '#fff',
      id: 'tooltip-parent-element',
      className: 'tooltip-parent-element',
    }
    const tooltipStyles = (!isCGRAVE && !isContinuumSite) ? getTooltipStyles(theme) : graveStyle

  const currentCategoryName = useMemo(() => {
    return categoryList?.find((c) => c?.tagId === currentCategory)?.name || ''
  }, [categoryList, currentCategory])

  useEffect(() => {

    const resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        setResultTagsHeight(entry.target.getBoundingClientRect().height + (isLinkMode ? (is992 ? 200 : 250) : (is992 ? 144 : 353)))
      }
    })

    if (foundTagsRef?.current) {
      resizeObserver.observe(foundTagsRef?.current)
    }

    return () => {
      if (foundTagsRef?.current) {
        resizeObserver.unobserve(foundTagsRef?.current)
      }
    }
  }, [is992])

  if (isCreateMode) {
    return (
      <CreateTagComponent 
        onClose={() => setIsCreateMode(false)} 
        onCreateTag={onAfterTagCreate} 
      />
    )
  }

  return (
    <TagsSearchModalWrapper>
      {!isLinkMode && !is992 && (
        <LangSelectHolder>
          <BLangSwitcher
            currentLanguage={i18n.language}
            onLangSelect={onLangSelect}
            key="lang"
          />
        </LangSelectHolder>
      )}
      <TagsSearchModalContainer isMobileMenu={isMobileMenu}>
        {!isLinkMode && saveOnClick && (
          <TitleContainer>
            <TagsSearchTitle color={theme.tagSearch.titleColor}>
              {t(mode === 'link' ? 'select_single' : requiredTags ? 'select_required' : 'select')}
            </TagsSearchTitle>
            <SubmitButton className='select-tags-modal--save-button' onClick={onSaveTagsByClick}>{t('save_tag')}</SubmitButton>
          </TitleContainer>
        )}
        {!isLinkMode && !saveOnClick && (
          <TagsSearchTitle color={theme.tagSearch.titleColor}>
            {t(isTagEditor ? 'tag_editor' : mode === 'link' ? 'select_single' : requiredTags ? 'select_required' : 'select')}
          </TagsSearchTitle>
        )}
        {!hideGlobalSearchBar && !(isHseSpace && isCompetencies) && (
          <TagsSearchInputWrapper
            isCGRAVE={isCGRAVE || isContinuumSite}
            offsetTop={(is992 && isMobileMenu) ? 20 : isLinkMode ? 0 : (is992 ? 16 : 48)}
            isMobileMenu={is992 && isMobileMenu}
            gx={12}
          >
            <SearchIcon fill={theme.tags.modal.search.color}/>
            <TagsSearchInput
              ref={mainSearchRef}
              onInput={debounceEvent(onInputText, 1000)}
              placeholder={t('tags_modal.search_mobile')}
            />
          </TagsSearchInputWrapper>
        )}
        {(!isMobile && !isGlobalEmptySearch) && (
          <TagsSearchSelection
            ref={foundTagsRef}
            style={{
              display: 'flex',
              flexFlow: 'row',
              margin: '0',
              paddingTop: innerValue.length > 0 ? '24px' : '8px',
              paddingBottom: innerValue.length > 0 ? '14px' : 0,
            }}>
            {!isLinkMode && !!innerValue.length && (
              <TagsSelectedTitle
                style={{ display: 'inline-flex', placeItems: 'center', whiteSpace: 'nowrap' }}
              >
                {(!!innerValue.length && mode !== 'link') ? (isTagEditor ? `${t('tags_in_project')}:` : `${t('tags_modal.selected_tags')}:`) : t('tags_modal.select_tags')}
              </TagsSelectedTitle>
            )}
            {
              // @ts-ignore
              !!innerLocalValue.length && (
                <BTagsGridNew className='selected-tags-grid'>
                  {mode !== 'link' &&
                  // @ts-ignore
                  innerLocalValue.map((v: any) => (
                    <BTag
                      tag={v}
                      removable={true}
                      key={v.tagId}
                      educational={isRequired(v)}
                      organization={v?.isTeamTag}
                      showRemoveIcon={!(isTagEditor && !editableTags.includes(v.tagId) && !(bProfile.isModer(profile) || bProfile.isSuperModer(profile)))}
                      disabled={!!isTagEditor && !editableTags.includes(v.tagId) && !(bProfile.isModer(profile) || bProfile.isSuperModer(profile))}
                      onIconClick={() => {
                        if (isTagEditor && !editableTags.includes(v.tagId) && !(bProfile.isModer(profile) || bProfile.isSuperModer(profile))) {
                            return;
                        }
                        if (protectedTags.includes(v.tagId)) {
                          toasts.error('Это обязательный тег');
                        } else {
                          const vi = innerValue.filter((t) => t.tagId !== v.tagId);
                          ReactTooltip.hide()
                          setInnerValue(vi);
                        }
                      }}
                    >
                      {bTag.title(v)}
                    </BTag>
                  ))}
                </BTagsGridNew>
              )}
          </TagsSearchSelection>
        )}
          {isTagEditor &&
              <TagsAvailableTitle
              style={{ display: 'inline-flex', placeItems: 'center', whiteSpace: 'nowrap' }}
          >
            {t('available_tags_in_project')}
          </TagsAvailableTitle>}
        <TagsSearchResultsWrapper
            direction={isViewAllTagsMode ? 'column' : 'row'}
            gx={is992 ? 16 : 24}
            offsetTop={!!innerValue?.length ? 16 : 22}
            shadowColor={theme.app.backgroundColor}
        >
          {isGlobalEmptySearch && !isLoading && (
            <EmptyTextWrapper direction="column" gy={24} isIqMediia={isIqMediia} width="100%" align="center" justify="center">
              <EmptyText>{t("tags_modal.empty_search")}</EmptyText>
              {(isTagAdminPage || viewAllTags) && <CreateTagButton onClick={() => setIsCreateMode(true)}>{t("tags_modal.create_tag")}</CreateTagButton>}
            </EmptyTextWrapper>
          )}
          {categoryVisible && !isGlobalEmptySearch && (
              <>
                <CategoryList
                    tags={categoryList}
                    // @ts-ignore
                    onHover={handleCategoryHover}
                    currentCategory={currentCategory}
                    customHeight={is992 ? 330 : resultTagsHeight}
                    isClickable={isLinkMode}
                    setHideMore={setHideMore}
                />
                {is992 && <ModalContextSplitLine/>}
              </>
          )}
          {isLoading && (
            <FlexBox justify="center" width='100%' style={{ height: resultTagsHeight }}>
              <LoaderSpinner color={theme.selectContextModal.loaderText} text={t('project_edit.modal.load_msg_tag')}/>
            </FlexBox>
          )}
          {!isLoading && (
            <TagsSearchResults
              customHeight={resultTagsHeight}
              direction={'column'}
              directionMobile={"column"}
              width={'100%'}
              // @ts-ignore
              ref={tagSearchListRef}
            >
              <TagsSearchResultsContext
                  direction={'column'}
                  directionMobile={'column'}
                  width={'100%'}
                  isGlobalSearch={isGlobalSearch}
              >
                <BTagsGridNew
                    style={{
                      position: 'relative',
                      height: 'auto',
                      paddingBottom: '10px'
                    }}
                    noLimitMaxHeight
                >
                  {<TabletTitle
                      onClick={() => {
                        if (!is992) return;
                        history.push(CreateLinkTo.tag(currentCategory || ''));
                      }}
                      width='100%' gx={8} offsetBottom={is992 ? 14 : 4} align="center"><span>{currentCategoryName}</span>{is992 && <ArrowTopRightIcon/>}</TabletTitle>}
                  {searchedItems
                    .map((g: any) => {
                      const items = isViewAllTagsMode ? g?.tags : g?.childrens;
                      return (
                        <TagsSearchResultsItem
                          hideMore={hideMore}
                          setHideMore={setHideMore}
                          isViewAllTagsMode={viewAllTags}
                          search={searchText}
                          key={g?.categoryId}
                          activeTagId={activeTag.current || ''}
                          title={g?.categoryTitle}
                          identifier={g?.categoryId}
                          items={items}
                          found={g?.found}
                          isCategorySearchNeed={g?.isSearchButton}
                          searchingIntoTag={isLocalSearch}
                          isSelected={(id) => innerValue.some((v) => v?.tagId === id)}
                          isCategoryTag={g?.isTagCategory}
                          onClick={(tag: any, selected) => {
                            let v = innerValue;
                            if (!selected) {
                              const educationalTags = innerValue.filter(({ isEducationTag }: any) => isEducationTag);

                              if (maxEducationalTags !== undefined && tag?.isEducationTag && educationalTags?.length + 1 > maxEducationalTags) {
                                toasts.error(maxEducationalTags > 1
                                  ? t('project_edit.max_education_tags_error', { count: maxEducationalTags })
                                  : t('project_edit.max_required_tags_error'))
                              } else {
                                v = mode === 'link' || (max && innerValue?.length + 1 > max) ? [tag] : [...innerValue, tag];
                              }
                            } else if (protectedTags.includes(tag?.tagId)) {
                              toasts.error('Это обязательный тег');
                              return;
                            } else {
                              v = innerValue.filter((t) => t.tagId !== tag.tagId);
                            }
                            setInnerValue(v);
                          }}
                          onTagArrowClick={handleToggleChildrenClick}
                          onParentClick={handleSetUrlClick}
                          onMoreClick={handleMoreClick}
                          onSearchInputChange={(e) => handleSearchIntoTagChange(e, g?.categoryId, LOAD_TYPE.tagsSearchIntoCategory)}
                          onSearchIntoCategory={(e) => handleSearchIntoTagChange(e, g?.categoryId, LOAD_TYPE.tagsSearchIntoCategory)}
                          setIsOpenTag={setIsOpenTag}
                          isEditPage={isEdit || isCreateLocationPage}
                          loadType={loadType}
                          isEmptySearch={isEmptySearchForAddintTags}
                          tagsFilter={tagsFilter}
                          setTime={setTime}
                          isGlobalSearch={isGlobalSearch}
                          isShowAll={g.isShowAll}
                          isLinkMode={isLinkMode}
                          isCreateLocationPage={isCreateLocationPage}
                        />
                      );
                    })}
                  <ReactTooltip  {...tooltipStyles}/>
                </BTagsGridNew>
              </TagsSearchResultsContext>
              {isViewAllTagsMode && (
                <SimplePagination 
                  page={Number(page || 1)} 
                  //@ts-ignore
                  pages={parseFloat((tagsAllRu?.count / ALL_TAGS_LIMIT).toFixed())} 
                  onPageChange={handlePageChange} 
                  disableOffset
                />
              )}
            </TagsSearchResults>
          )}
        </TagsSearchResultsWrapper>
      </TagsSearchModalContainer>
      <ReactTooltip/>
    </TagsSearchModalWrapper>
  );
};
